import React, { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Card, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementComplex from "../../../core/api/api.amusementComplex";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import ChangeOrderAmusementService from "./ChangeOrderAmusementService";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const AmusementComplex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [selectedComplexId, setSelectedComplexId] = useState(null);
  const [showModalAmusementsOrder, setShowModalAmusementsOrder] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const cityIdFromUrl1 = searchParams.get("cityId");
  const groupIdFromUrl1 = searchParams.get("groupId");
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAmusementComplex.getAll({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
          cityIdList: _.isEmpty(cityIdFromUrl1) ? null : cityIdFromUrl1.split(","),
          groupId: _.isEmpty(groupIdFromUrl1) ? 0 : _.toString(groupIdFromUrl1),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        // const result = await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 });
        // setListAmusementGroup(result.data);
        const response = await ApiRegion.getAllCity();
        setAllAmusementCityList(response);
        const formInputs = [
          { name: "cityId", type: "multiSelect", data: response },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();

  }, []);

  const inputChangeHandlerCity = (event) => {
    setValue("cityId", event);
  };
  const onSubmit = async (data) => {
    if (data.cityId?.length > 0) data.cityId = _.toString(data.cityId?.map((item) => item.value));
    data.groupId = !_.isEmpty(data.groupId) ? data.groupId?.value : data.groupId;

    const apiData = await ApiAmusementComplex.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
      cityIdList: data.cityId,
      groupId: data.groupId,
    });
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/AmusementComplex?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت مجتمع تفریحی</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست مجتمع های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Link
              to={{
                pathname: `/createEditAmusementComplex/0`,
              }}
              className="btn btn-primary"
            >
              <AddCircle className="mr-1" />
              ایجاد مجتمع تفریحی جدید
            </Link>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body className="px-0">
                        <Row>
                          <Col sm="6" xl="3">
                            <Controller
                              name="cityId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0"
                                  placeholder="انتخاب شهر"
                                  options={allAmusementCityList?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  field={field}
                                  onChange={inputChangeHandlerCity}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SearchIcon />{" "}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setSelectedComplexId={setSelectedComplexId}
                  setShowModalAmusementsOrder={setShowModalAmusementsOrder}
                />
              </Col>
              {showModalAmusementsOrder && (
                <ChangeOrderAmusementService
                  showModalAmusementsOrder={showModalAmusementsOrder}
                  setShowModalAmusementsOrder={setShowModalAmusementsOrder}
                  selectedComplexId={selectedComplexId}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default AmusementComplex;
